import React, { Fragment } from 'react';
import GenericBanner from './GenericBanner';

export default class LeftAlignedHero extends React.Component {
    render() {
        return (
            <GenericBanner {...this.props} controlType={GenericBanner.ControlTypes.LeftAlignedHero} showJumpLink={true}>
            </GenericBanner>
        )
    }
}
